import { useSearchParams } from "react-router-dom"

import { DateHelper } from "@/utils"
const useDefaulterSearchParams = () => {
  const [searchParams] = useSearchParams()
  const stringStartDate = DateHelper.subDays(7)
  const stringEndDate = DateHelper.currentDate()
  const startDateTime = new Date(
    DateHelper.formatToISO(stringStartDate)
  )
  const endDateTime = new Date(
    DateHelper.formatToISO(stringEndDate)
  )
  const params: DefaultersSearchParams = {
    page: Number(searchParams.get("page")) || 0,
    quantity: Number(searchParams.get("pageSize")) || 10,
    startDateTime:
      searchParams.get("startDateTime") || stringStartDate,
    endDateTime:
      searchParams.get("endDateTime") || stringEndDate,
    queryType: searchParams.get("queryType") || "ALL",
    name: searchParams.get("name") || undefined,
    ownId: searchParams.get("ownId") || undefined,
    document: searchParams.get("document") || undefined,
    code: searchParams.get("code") || undefined,
    tab: searchParams.get("tab") || "recurring",
    refetch: searchParams.get("refetch") || "false",
  }
  return {
    params,
    startDateTime,
    endDateTime,
  }
}
export default useDefaulterSearchParams
